import React from "react";
import { routes } from "../const/routes";
import { IconSvg } from "../components/IconSvg";
export var MenuItems = [
  // {
  //   name: "Главная",
  //   array: [
  //     {
  //       path: routes.news.path,
  //       name: "Новости",
  //     },
  //     {
  //       path: routes.howToStart.path,
  //       name: "С чего начать?",
  //     },
  //     {
  //       path: routes.triathlonHistory.path,
  //       name: "История",
  //     },
  //   ],
  // },
  {
    name: "Федерация",
    array: [
      {
        path: routes.federation.path,
        name: "Цели и задачи",
      },
      {
        path: routes.management.path,
        name: "Руководство",
      },
      {
        path: routes.accreditation.path,
        name: "Документы",
      },
      {
        path: routes.contacts.path,
        name: "Контакты",
      },
      {
        path: routes.antidoping.path,
        name: "Антидопинг",
      }, // {
      //   path: routes.congratulationsPage.path,
      //   name: "Поздравления",
      // },
    ],
  }, // {
  //   name: "Отделения",
  //   array: [
  //     {
  //       path: routes.triathlonDepartments.path,
  //       name: 'Интерактивная карта',
  //     },
  //   ],
  // },
  {
    name: "Сборная",
    array: [
      {
        path: routes.mainCast.path,
        name: "Спортсмены",
      },
      {
        path: routes.coachingStaff.path,
        name: "Тренеры",
      },
    ],
  }, // {
  //   name: "Медиа",
  //   array: [
  //     {
  //       path: routes.mediaPhoto.path,
  //       name: "Фото",
  //     },
  //     {
  //       path: routes.mediaVideo.path,
  //       name: "Видео",
  //     },
  //   ],
  // },
];
export var headerLinks = [
  {
    path: routes.triathlonDepartments.path,
    name: "Отделения",
  },
  {
    path: routes.news.path,
    name: "Новости",
  },
  {
    path: routes.education.path,
    name: "Образование",
  },
  {
    path: routes.calendar.path,
    name: "Календарь",
  }, // {
  //   path: routes.events.path,
  //   name: "Мероприятия",
  // },
  {
    path: routes.results.path,
    name: "Результаты",
  },
];
export var authPage = [
  {
    path: routes.auth.path,
    name: "Личный кабинет",
    icon: /*#__PURE__*/ React.createElement(IconSvg, {
      src: "user",
      color: "#444444",
    }),
  },
];
